import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import productType from "../../assets/img/product-type-icon.svg";
import imageIcon from "../../assets/img/image-icon.svg";
import pricingIcon from "../../assets/img/pricing.svg";
import tickIconPrimary from "../../assets/img/white-tick-icon.svg";
import descriptionIcon from "../../assets/img/description.svg";
import infoIcon from "../../assets/img/info.svg";
import customTheme from "../../assets/img/custom-theme.png";
import filesIcon from "../../assets/img/files.svg";
import returnIcon from "../../assets/img/modals/return.svg";
import removeicon from "../../assets/img/products/removeicon.svg";
import * as $ from "jquery";
import { Link, useHistory } from "react-router-dom";
import { Alert, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import CroppieModal from "../croppie-modal";
import { hideLoader, showLoader } from "../loader";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../utils/url";
import ErrorMessage from "../errors/errorMessage";
import ModalErrors from "../errors/modal-errors";
import FormFieldError from "../errors/formFieldError";
import ProductStep2 from "./productStep2";
import SelectedThemeInput from "../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../custom-theme/commons/select-custom-theme";
import IroColorPicker from "../custom-theme/IroColorPicker";
const ProductStep1 = ({button_url, set_button_url, logo, setLogo, showProductStep1, setShowProductStep1, nextStep, onClose, title, setTitle ,error, setError ,short_description, setShort_Description , accent_theme, setAccent_Theme ,errorMessage, setErrorMessage ,product_slug, setProductSlug, company_name, setCompanyName}) => {
    const history  = useHistory();
    const { basePath, slug } = useSelector((state) => state?.slugReducer);
    const [croppie_image, setcroppie_image] = useState({ url: "", id: null });
    const [croppie, setCroppie] = useState(null);
    const [showCroppieModal, setshowCroppieModal] = useState(null);

    const fileupload = useRef(null);
    // const handleopenmodal = (e) => {
    //     const fileList = e.target.files[0];
    //     var reader = new FileReader();

    //     reader.onload = function (event) {
    //         setLogo(event.target.result);
    //     };
    //     reader.readAsDataURL(fileList);
    // };
    // const onClose = () => {
    //     closeProductType();
    //     setShowProductStep1(false)
    //     history.push(basePath + "/campaigns")
    // };

    const handleCompanyNameChange = (e) => {
        setCompanyName(e.target.value)
      }
      const themeChange = () => { 
        $('.color-picker-modal').removeClass("d-none");  
        $('.color-picker-main').removeClass("d-none");   
        $('.color-picker-modal').addClass("d-flex");
        $('.color-picker-main').addClass("d-flex");
    };
    const colorChange = (color) => {
        setAccent_Theme(color)
    }
    // const handleopenmodal = (e) => {
    //     setcroppie_image({ url: "", id: null, name: null, type: null });
    //     generate_image_preview(e.target);
    //     hideLoader();
    // };
    // function generate_image_preview(input) {
    //     showLoader();
    //     if (input.files && input.files[0]) {
    //         let reader = new FileReader();
    //         if (input.files[0].size >= 5242880) {
    //         $("#image_file_input").val("");
    //         let notification_container = $(".notification-container");
    //         toast.error("File Size Should not exceed 5MBs");
    //         // showModal();
    //         return;
    //         }
    //         let val = input.files[0].name;
    //         let valid_extensions = ["png", "jpg", "jpeg"];
    //         let extension =
    //         val.substring(val.lastIndexOf(".") + 1, val.length) || val;
    //         if (!valid_extensions.includes(extension)) {
    //         $("#image_file_input").val("");
    //         let notification_container = $(".notification-container");
    //         toast.error("Invalid Image File. Should be png, jpg or jpeg");
    //         // showModal();
    //         return;
    //         }
    //         reader.onload = (event) => {
    //         setcroppie_image({
    //             ...croppie_image,
    //             url: event.target.result,
    //         });
    //         console.log(setcroppie_image);
    //         console.log("setcroppie_image", croppie_image);
    //         setshowCroppieModal(true);
    //         setTimeout(() => {
    //             const el = document.getElementById("image_demo2");
    //             try {
    //             console.log("el", el);
    //             if (el) {
    //                 var croppieInstance = new Croppie(el, {
    //                 enableExif: true,
    //                 viewport: {
    //                     width: 850,
    //                     height: 470,
    //                     type: "square",
    //                 },
    //                 boundary: {
    //                     width: 870,
    //                     height: 570,
    //                 },
    //                 });
    //                 croppieInstance
    //                 .bind({
    //                     url: event.target.result,
    //                 })
    //                 .then(function () {
    //                     console.log("jQuery bind complete");
    //                     setTimeout(() => { }, 300);
    //                 })
    //                 .catch(() => {
    //                     croppieClose();
    //                 });
    //                 setCroppie(croppieInstance);
    //             }
    //             } catch { }
    //         }, 500);
    //         };
    //         reader.readAsDataURL(input.files[0]);
    //     }
    // }
    // const croppedImage = () => {
    //     if (croppie !== null) {
    //       croppie
    //         .result({
    //           type: "canvas",
    //           size: "original",
    //           format: "png",
    //           quality: 1,
    //         })
    //         .then((response) => {
    //           const tempObj = { image_url: response };
    //           croppie
    //             .result({
    //               size: "viewport",
    //               format: "png",
    //               quality: 1,
    //               type: "blob",
    //             })
    //             .then((res) => {
    //                 setLogo(response)
    //               croppieClose()
    //             });
    //         });
    //     }
    // };
    // const handleHideModal = () => {
    //     setshowCroppieModal(false);
    //     setCroppie(null);
    //     setcroppie_image({ url: "", id: null });
    // };
    // const croppieClose = () => {
    //     showLoader();
    //     setshowCroppieModal(false);
    //     setCroppie(null);
    //     setTimeout(() => {
    //         hideLoader();
    //     }, 400);
    // };
    const onfilechange = (e) => {
        const fileList = e.target.files[0];
        var reader = new FileReader();

        reader.onload = function (event) {
            setLogo(event.target.result);
        };
        reader.readAsDataURL(fileList);
    }
    return (
        <Modal centered id="newProductModal" show={showProductStep1} onHide={onClose}>
            <div className="modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <form name="product_type" method="post" role="form">
                            <div className="notification-container"></div>
                            <div className="form-group">
                                <img src={productType} width="40px" alt=""  />
                                <h4 className="productHead1 mt-10px">Let’s build your campaign</h4>
                            </div>
                            <div>
                            <ErrorMessage error={error} />
                                <div className="form-group mt-20px">
                                        <label className="productlabels">
                                            Campaign Title
                                            <small className="text-red">*</small>
                                        </label>
                                        <input
                                            value={title}
                                            onChange={(e) => {
                                                setTitle(e.target.value)
                                                let slug = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-');
                                                slug = slug.replaceAll(' ', '-');
                                                setProductSlug(slug)
                                            }}
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="title"
                                            placeholder="eg: May SaaS Leads"
                                        />
                                        <FormFieldError error={error?.title} />
                                    </div>
                                <div class="form-group mt-20px">
                                    <div className="d-flex align-items-center py-1">
                                        <label class="text-gray font-14-u">Company Logo</label>
                                    </div>
                                    <div class="mb-3 d-flex ps-0 zaap-border-rounded py-2" style={{ borderColor: '#E8E9EA', gap: "7px" }}>
                                        {logo ? <img className="dropzone-wrapper dropzone-wrapper5 fav-uplod" src={logo} /> : null}
                                        <div className="d-flex justify-content-end uplod-btn-u">
                                            <input id="file-upload" type="file" ref={fileupload} className="d-none" accept=".png,.jpg,.jpeg" name="logo"  onChange={onfilechange} />
                                            <button type="button" onClick={() => fileupload.current.click()} class="btn btn-semi-rounded d-flex align-items-center justify-content-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/>
                                                </svg>
                                                <span class="upload-text">Upload New</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mt-20px">
                                    <label className="productlabels">
                                        Company Name
                                        <small className="text-red">*</small>
                                    </label>
                                    <input
                                        value={company_name}
                                        onChange={(e) => handleCompanyNameChange(e)}
                                        type="text"
                                        className="zaapGlobal-input"
                                        name="title"
                                        placeholder="Your Company"
                                    />
                                    <FormFieldError error={error?.title} />
                                </div>
                                <div className="form-group mt-20px">
                                    <label className="productlabels">
                                        Product/Service Description
                                        <small className="text-red">*</small>
                                    </label>
                                    <input
                                        value={short_description}
                                        onChange={(a) =>
                                            setShort_Description(a.target.value)
                                        }
                                        type="text"
                                        className="zaapGlobal-input"
                                        name="short_description"
                                        placeholder="eg: We make custom videos to grow your organic reach"
                                    />
                                </div>
                                <div className="form-group mt-20px">
                                    <div className="col-6 pl-0 d-flex align-items-center" id="header-theme">
                                        <span className="zaap-normal-text">Brand Color</span>
                                    </div>
                                    
                                    <SelectedThemeInput data_type={"brand_color"} themeType="brand_color" color={accent_theme}  themeChange={themeChange}/>
                                    <SelectedCustomTheme nthChild="" themeType="brand_color" color={accent_theme} from={'campaigns'} colorChange={colorChange}/>
                                </div>
                                <div className="form-group mt-20px">
                                <label className="productlabels">
                                    Link to Book Meeting
                                </label>
                                <input value={button_url} onChange={(a) => set_button_url(a.target.value)}
                                    type="url"
                                    className="zaapGlobal-input"
                                    name="button_url"
                                    placeholder="eg: https://calendaly.com/michael"
                                />
                                </div>
                            </div>
                        </form>
                    </div>
                        <div class="modal-foot-u">
                            <div class="text-center d-flex submit-buttons-fixed">
                                <button onClick={nextStep} type="button" class="project-blue-btn">
                                    <b>Next Step</b>
                                    <small class="project-blue-btn-badge">
                                        <img src={returnIcon} alt="" />
                                    </small>
                                </button>
                            </div>
                        </div>
                </div>
            </div>
            {/* <CroppieModal show={showCroppieModal} handleHide={handleHideModal} croppieClose={croppieClose} croppedImage={croppedImage} modalWidth={500} productCroppie={"productCroppie"} /> */}
        </Modal>
    );
};
export default ProductStep1;
